import { twMerge } from 'tailwind-merge'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc.js'
import Icon from '@/components/atoms/Icon'

dayjs.extend(utc)
dayjs.locale('pt-br')

interface Course {
	id: number
	name: string
	capa_card: string
	progress: string
	status: string
}

interface CardCourseProps {
	course: Course
	className?: string
	onClick?: () => void
}

export function CardCourse({ course, className, onClick }: CardCourseProps) {
	const isCertificated = course.status === 'CERTIFICATE'

	return (
		<Link
			to='/curso'
			className={twMerge(
				className,
				'relative overflow-clip w-full h-full flex-1 bg-[#2D1E3E] rounded-[10px] flex flex-col border border-[#3F3F46] cursor-pointer group hover:border-brand-primary'
			)}
			onClick={onClick}
		>
			<div className='absolute w-full h-full z-10'>
				<img
					src={course.capa_card}
					width='100%'
					height='100%'
					alt='Imagem do card de curso'
					className='absolute inset-0 w-full h-full top-0 right-0 bottom-0 object-fill'
				/>
			</div>

			{(() => {
				if (isCertificated) {
					return (
						<div className='absolute flex items-center gap-2 top-4 left-4 rounded-full bg-dark-green z-50 py-1 px-2 pr-3 h-8'>
							<svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
								<g clip-path='url(#clip0_315_1716)'>
									<path
										d='M14.535 6.66666C14.8395 8.16086 14.6225 9.71427 13.9203 11.0679C13.218 12.4214 12.073 13.4934 10.6761 14.1049C9.27913 14.7164 7.71479 14.8305 6.24391 14.4282C4.77302 14.026 3.4845 13.1316 2.59323 11.8943C1.70195 10.657 1.26179 9.15148 1.34615 7.62892C1.43051 6.10635 2.0343 4.65872 3.05681 3.52744C4.07932 2.39616 5.45876 1.64961 6.96509 1.4123C8.47141 1.17498 10.0136 1.46123 11.3344 2.22333'
										stroke='#87F3BE'
										strokeWidth='1.5'
										strokeLinecap='round'
										strokeLinejoin='round'
									/>
									<path
										d='M6 7.33317L8 9.33317L14.6667 2.6665'
										stroke='#87F3BE'
										strokeWidth='1.5'
										strokeLinecap='round'
										strokeLinejoin='round'
									/>
								</g>
								<defs>
									<clipPath id='clip0_315_1716'>
										<rect width='16' height='16' fill='white' />
									</clipPath>
								</defs>
							</svg>

							<p className='text-light-green text-base font-medium leading-4'>
								Completo
							</p>
						</div>
					)
				}

				return (
					<div className='absolute flex items-center gap-2 top-4 left-4 rounded-full bg-black/80 z-50 py-1 px-2 h-8'>
						<svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
							<circle
								cx='8'
								cy='8'
								r='6'
								stroke='white'
								strokeOpacity='0.2'
								strokeWidth='4'
							/>
							<circle
								cx='8'
								cy='8'
								r='6'
								stroke='#FAFAFA'
								strokeWidth='4'
								fill='transparent'
								strokeDasharray={2 * Math.PI * 6}
								strokeDashoffset={
									2 * Math.PI * 6 -
									(parseFloat(course.progress.replace('%', '')) / 100) *
										(2 * Math.PI * 6)
								}
								strokeLinecap='round'
								transform='rotate(-90 8 8)'
							/>
						</svg>

						<p className='text-zinc-50 text-base font-medium leading-4'>
							{`${Math.round(parseFloat(course.progress.replace('%', '')))}%`}{' '}
							completo
						</p>
					</div>
				)
			})()}

			<div className='flex w-9 h-9 items-center justify-center rounded-full bg-brand-primary opacity-0 absolute bottom-4 right-4 z-50 group-hover:opacity-100 duration-200'>
				<Icon
					name='arrow-top-hover-new'
					width='24px'
					height='24px'
					className='text-brand-primary'
				/>
			</div>
		</Link>
	)
}
